import FleetAdminAction from 'components/FleetAdminAction';
import useFleetAdminPermissions from 'utils/User/useFleetAdminPermissions';

import AddAssetMenu from '../Account/Depots/AddAssetModal/AddAssetMenu';

import BulkAddAssetModal from './BulkAddAssetModal';
import BulkAddAssetProvider, {
  useBulkAddAssetContext,
} from './BulkAddAssetModal/context/BulkAddAssetContext';

function BulkAddAssetControls() {
  const { isModalOpen, openModal } = useBulkAddAssetContext();
  const fleetAdminPermissions = useFleetAdminPermissions();
  const manageAssetsCapability =
    fleetAdminPermissions.anyAccount('canManageAssets');

  return (
    <>
      <FleetAdminAction capability={manageAssetsCapability}>
        {({ disabled }) => (
          <AddAssetMenu disabled={disabled} onSelectBulk={openModal} />
        )}
      </FleetAdminAction>
      {isModalOpen && <BulkAddAssetModal />}
    </>
  );
}

export default function BulkAddAssetButton() {
  return (
    <BulkAddAssetProvider>
      <BulkAddAssetControls />
    </BulkAddAssetProvider>
  );
}
